export default {
    'pharmaceutical-forms': 'الأشكال الدوائية',
    'add-product': 'إضافة منتج',
    'edit-product': 'تعديل منتج',
    'the-product': 'بيانات المنتج؟'
}